import "./styles.scss";
import React, { FC } from "react";

interface IProps {
  title: string;
  fullText?: string;
  url?: string;
  tags?: any; //[{ display_name: string }];
}

const HighlightCardMacro: FC<IProps> = (props: IProps) => {
  const { title, fullText, url, tags = [] } = props;

  return (
    <div className="ps-highlight-card-macro">
      <h4>{title}</h4>

      {tags.length > 0 && (
        <div className="ps-highlight-card__tag-container">
          {tags.map((tag, idx) => (
            <div className="ps-highlight-card__tag" key={idx}>
              {tag.display_name}
            </div>
          ))}
        </div>
      )}

      {tags.length === 0 && (
        <React.Fragment>
          {url ? (
            <a href={url} target="_blank" rel="noreferrer">
              <p>{fullText}</p>
            </a>
          ) : (
            <p>{fullText}</p>
          )}
        </React.Fragment>
      )}
    </div>
  );
};
export default HighlightCardMacro;
